<template>
  <div>
    <div class="mb-5">
      <label class="h6">{{ trans("journal.reflections.service") }}</label>
      <ul class="list-unstyled services mb-0">
        <li v-for="(service, index) of services" :key="index">
          <b-link
            class="d-block font-weight-bold w-100 py-3 h6 mb-0"
            :class="{ active: selectedProgram(service.value, service.type) }"
            @click="onFilterService(service.value, service.type)"
            >{{ service.text }}</b-link
          >
        </li>
      </ul>

      <label class="h6 mt-5">{{ trans("journal.reflections.order_by") }}</label>
      <b-select
        @change="onOrderByChange"
        v-model="orderByValue"
        class="custom-select"
        :options="orderOptions"
      />

      <label class="h6 mt-5">{{ trans("journal.reflections.filter_by") }}</label>
      <date-picker
        id="datepickerFrom"
        classes="mt-2 mb-2"
        :locale="userLocale"
        :value="from"
        :max="max"
        :placeholder="trans('journal.reflections.date_from')"
        v-on:getValue="onFilterData($event, 'min')"
      />
      <date-picker
        id="datepickerTo"
        classes="mb-2"
        :locale="userLocale"
        :value="to"
        :min="min"
        :placeholder="trans('journal.reflections.date_to')"
        v-on:getValue="onFilterData($event, 'max')"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import DatePicker from "../../atoms/DatePicker";

export default {
  name: "JournalReflectionsFilters",
  components: { DatePicker },
  props: {
    services: Array,
    orderBy: String,
    serviceId: Number,
    serviceType: String,
    from: String,
    to: String,
  },

  data() {
    return {
      orderByValue: "",
      min: null,
      max: null,
      dateTimestamp: {
        min: "",
        max: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      userLocale: "user/getLocale",
      reflectionsPars: "journal/getReflectionsPars",
    }),
    orderOptions: function () {
      return [
        { value: "desc", text: `${this.trans("journal.reflections.more_recent")}` },
        { value: "asc", text: `${this.trans("journal.reflections.less_recent")}` },
      ];
    },
  },
  methods: {
    ...mapMutations({
      setReflectionsSearchPars: "journal/setReflectionsSearchPars",
      setReflections: "journal/setReflections",
    }),
    onOrderByChange() {
      trackEvent("JournalReflectionSort", {});
      this.setReflectionsSearchPars({ currentPage: 1, lastPage: 1, order: this.orderByValue });
      this.setReflections([]);
      this.$emit("getReflections", {
        order: this.orderByValue,
        from: this.reflectionsPars.from,
        to: this.reflectionsPars.to,
        serviceId: this.reflectionsPars.serviceId,
      });
    },
    onFilterService(serviceId, serviceType) {
      trackEvent("JournalReflectionProgramfilter", {
        serviceId: serviceId,
        serviceType: serviceType,
      });

      this.setReflectionsSearchPars({
        currentPage: 1,
        lastPage: 1,
        serviceId: serviceId,
        serviceType: serviceType,
      });
      this.setReflections([]);
      this.$emit("getReflections", {
        order: this.orderByValue,
        from: this.reflectionsPars.from,
        to: this.reflectionsPars.to,
        serviceId: serviceId,
        serviceType: serviceType,
      });
    },
    onFilterData(e, type) {
      this[type] = e;

      this.dateTimestamp[type] = this[type];
      switch (type) {
        case "min":
          this.dateTimestamp[type] += " 00:00:00";
          break;
        case "max":
          this.dateTimestamp[type] += " 23:59:59";
          break;
      }

      //set a default value
      if (this.dateTimestamp.min != "" && this.dateTimestamp.max == "") {
        const today = new Date();
        this.dateTimestamp.max =
          today.getFullYear() +
          "-" +
          ("0" + (today.getMonth() + 1)).slice(-2) +
          "-" +
          today.getDate() +
          " 23:59:59";
      } else if (this.dateTimestamp.min == "" && this.dateTimestamp.max != "")
        this.dateTimestamp.min = "2015-01-01" + " 00:00:00";

      trackEvent("JournalReflectionTimeFilter", {});
      this.setReflectionsSearchPars({
        currentPage: 1,
        lastPage: 1,
        from: this.dateTimestamp.min,
        to: this.dateTimestamp.max,
      });
      this.setReflections([]);
      this.$emit("getReflections", {
        order: this.orderByValue,
        from: this.dateTimestamp.min,
        to: this.dateTimestamp.max,
        serviceId: this.reflectionsPars.serviceId,
      });
    },
    selectedProgram(serviceId, serviceType) {
      return this.serviceId === serviceId && this.serviceType === serviceType;
    },
  },
  mounted() {
    this.orderByValue = this.orderBy;

    if (this.from) this.dateTimestamp.min = this.from;
    if (this.to) this.dateTimestamp.max = this.to;
  },
};
</script>

<style lang="scss" scoped>
ul.services {
  li {
    border-bottom: 1px solid $color-light;

    &:last-child {
      border: 0;
    }

    a {
      color: $color-dark;
      text-decoration: none;

      &:hover,
      &.active {
        color: $color-blue;
      }
    }
  }
}
</style>
